import React, { ReactNode } from "react";
import { Theme, makeStyles } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) => ({
	panelWrapper: {
		margin: "0 auto",
		padding: 30,
		maxWidth: 1500,
		marginTop: (reduceMargins: boolean) => reduceMargins ? 0 : theme.spacing(2),
		[theme.breakpoints.down("sm")]: {
			padding: (reduceMargins: boolean) => reduceMargins ? "0px 15px 15px 15px" : 15,
			width: "100%",
		},
	},
	fullwidth: {
		maxWidth: "inherit",
	},
}));
interface MyPagePanelProps {
	className?: string;
	fullWidth?: boolean;
	children?: ReactNode;
	reduceMargins?: boolean
}
export const MyPagePanel = (props: MyPagePanelProps) => {
	const { className, fullWidth = false, reduceMargins = false, ...restProps } = props;
	const classes = useStyles(reduceMargins);
	return (
		<div
			className={clsx(
				classes.panelWrapper,
				fullWidth ? classes.fullwidth : {},
				className
			)}
			{...restProps}
		></div>
	);
};
